import React, { useMemo } from "react";
import { ColDef } from "ag-grid-community";
import locale, { dateFormat } from "@bonliva-crm/locale";
import { TravelRequestTableColumns } from "@bonliva-crm/shared";
import moment from "moment";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { Typography } from "@material-ui/core";

export function useInitialColumnDefs(): Array<ColDef<any>> {
  const defs = useMemo(() => {
    const result: Array<ColDef> = [];

    result.push({
      field: TravelRequestTableColumns.City,
      headerName: locale.travelRequestTableColumns.City,
      valueGetter: (params) => {
        return params.data?.city ?? "";
      },
      wrapText: true,
      sortable: false
    });

    result.push({
      field: TravelRequestTableColumns.DepartureDate,
      headerName: locale.travelRequestTableColumns.DepartureDate,
      valueGetter: (params) => {
        return params.data?.firstDeparture
          ? moment(params.data?.firstDeparture).format(dateFormat)
          : "";
      },
      wrapText: true,
      sortable: false
    });

    result.push({
      field: TravelRequestTableColumns.Sender,
      headerName: locale.travelRequestTableColumns.Sender,
      valueGetter: (params) => {
        return params.data?.createdBy?.Name ?? "";
      },
      wrapText: true,
      sortable: false
    });

    result.push({
      field: TravelRequestTableColumns.Consultant,
      headerName: locale.travelRequestTableColumns.Consultant,
      wrapText: true,
      sortable: false,
      valueGetter: (params) => {
        return params.data?.consultantName ?? "";
      }
    });

    result.push({
      field: TravelRequestTableColumns.Week,
      headerName: locale.travelRequestTableColumns.Week,
      wrapText: true,
      sortable: false,
      cellRenderer: (props) => {
        if (!props.data?.weeks?.length) {
          return "";
        }

        return (
          <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
            {props.data?.weeks?.map((x, i) => (
              <Typography
                key={i}
                color={"primary"}
                style={{
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center"
                }}
                onClick={(e) => {
                  e.preventDefault();
                  window.open(x.link, "_blank");
                }}
              >
                {x.name}
                <OpenInNewIcon color={"inherit"} fontSize={"small"} />{" "}
              </Typography>
            ))}
          </div>
        );
      }
    });

    result.push({
      field: TravelRequestTableColumns.Status,
      headerName: locale.travelRequestTableColumns.Status,
      wrapText: true,
      sortable: false,
      valueGetter: (params) => {
        return params.data?.status?.status
          ? locale.accommodationRequestStatusType[params.data.status.status]
          : "";
      }
    });

    result.push({
      field: TravelRequestTableColumns.CreatedOn,
      headerName: locale.travelRequestTableColumns.CreatedOn,
      valueGetter: (params) => {
        return params.data?.createdOn
          ? `${moment(params.data?.createdOn).format(dateFormat)}`
          : "";
      },
      wrapText: true,
      sortable: false
    });

    return result;
  }, []);

  return defs;
}
